import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const ButtonGreen = styled(Button)(({ bgcolor, hoverBg }) => ({
  backgroundColor: bgcolor || '#E50218',
  borderRadius: '12px',
  fontSize: '16px',
  fontWeight: '600',
  textTransform: 'none',
  padding: '10px 7px',
  minHeight: '0px !important',
  color: 'white',
  '&:hover': {
    backgroundColor: hoverBg || 'rgba(229, 2, 24, 0.8)',
  },
}));

export default ButtonGreen;